
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/product-tutorial",
      function () {
        return require("private-next-pages/article/product-tutorial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/product-tutorial"])
      });
    }
  